/**
 * A themed group the public portal renders published dashboards under.
 * `key` is assigned server-side from `label` on create and never changes —
 * dashboards reference it via portalGroupKey.
 */
export class PortalDashboardGroup {
  id?: any;
  key?: string;
  label = '';
  description = '';
  sortOrder = 0;
}
